import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
    providedIn: 'root',
})
export class PermissionService {
    public allowedTenantGroups: string[] = [];
    private permissions: string[] = [];

    constructor(private cookieService: CookieService) {
        this.initPermissions();
    }

    initPermissions() {
        if (!this.cookieService.get('BaToolAuthFeatureRoles')) {
            return;
        }

        this.permissions = JSON.parse(this.cookieService.get('BaToolAuthFeatureRoles'));
        this.allowedTenantGroups = JSON.parse(this.cookieService.get('BaToolAuthAllowedTenantGroups'));
    }

    public hasPermission(permission: string): boolean {
        if (this.permissions.length === 0) {
            this.initPermissions()
        }

        return this.permissions.includes(permission);
    }

    public getPermissions(): string[] {
        if (this.permissions.length === 0) {
            this.initPermissions()
        }

        return this.permissions.slice();
    }

    public isAllowedTenant(tenantGroup: string): boolean {
        return this.allowedTenantGroups.includes(tenantGroup) ||
            this.allowedTenantGroups.includes('Master');
    }
}
